const message = {
	testimonialsOfOurPatients:
		"Testimonios de <br class='d-none d-lg-flex'>nuestros <span class='text-green'>pacientes</span>",
	condition: 'Condición',
	communityHealth: "<span class='text-green'>Salud</span> comunitaria",
	eventAndActivities: "Próximos eventos <br> y <span class='text-green'> actividades </span>",
	lastNews: "Últimas <span class='text-green'> noticias </span> ",
	keepReading: 'Seguir leyendo',
	whereToFindUs: "Dónde <span class='text-green'>encontrarnos</span> ",
	headquarters: "Sede ",
	schedule: "Lunes - Viernes <br>7:00 am a 4:00 pm<br>Sábados: 7:00am a 11:00 am",
	scheduleYourAppointment: "Agenda tu cita con solo un click",
	scheduleAnAppointment: "Agenda cita",
};
export default message;
